import { useState } from "react";
import Modal from "../modal";

function About({show, handleshow}) {
  /**
   *  Boton Aceptar
  */
  const handleLogin = async () => {
    handleshow(false);
  };
  return (
    <>
    <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Acerca De'}>
        
      <div className=" bg-light h-[20rem] w-[35rem]">
      
      <p className="text-gray-700">
          Are you sure you want to proceed?
      </p>

        
      </div>
      </Modal>
    

      </>
  );
}
export default About;
